module.exports = __webpack_public_path__ + "static/media/product_online_icon.62e85500.svg";